import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronUp } from "@fortawesome/free-solid-svg-icons";
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";

/**
 * Page header with gradient title and the "Start Crawling" toggle pill.
 */
export default function CrawlHeader({ formExpanded, onToggle }) {
  return (
    <div
      className="c-content-width"
      style={{
        padding: "8px 0 6px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      <h1
        style={{
          fontFamily: "'Host Grotesk', sans-serif",
          fontSize: "28px",
          fontWeight: 700,
          margin: 0,
          lineHeight: 1,
          color: "#1f2937",
          background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
          backgroundClip: "text",
        }}
      >
        Social Media Crawler
      </h1>

      <button
        onClick={onToggle}
        style={{
          display: "inline-flex",
          alignItems: "center",
          gap: "8px",
          outline: "none",
          cursor: "pointer",
          fontFamily: "'Host Grotesk', sans-serif",
          fontSize: "13px",
          fontWeight: 600,
          borderRadius: "20px",
          padding: "8px 20px",
          color: formExpanded ? "#667eea" : "#ffffff",
          background: formExpanded
            ? "#f0eeff"
            : "linear-gradient(180deg, #4079f0 0%, #2a5fe6 100%)",
          border: formExpanded
            ? "1.5px solid rgba(102, 126, 234, 0.3)"
            : "1.5px solid transparent",
          boxShadow: formExpanded
            ? "none"
            : "0 4px 14px rgba(53, 114, 239, 0.3)",
          transition: "all 0.25s cubic-bezier(0.4, 0, 0.2, 1)",
        }}
      >
        <FontAwesomeIcon
          icon={formExpanded ? faChevronUp : faMagnifyingGlass}
          style={{ fontSize: "12px" }}
        />
        {formExpanded ? "Close" : "Start Crawling"}
      </button>
    </div>
  );
}
